import React from "react";
import { ProfileWrapper } from "./MyProfile.styled";
import { Row, Col, Tag, Button, Popconfirm } from "components/common";
import { getUserPermissions } from "utils/text";

const ProfileInfo = ({ profileData, address, accessLevel, hanldeReset, isLoading }) => {
    return (
        <ProfileWrapper>
            <Row gutter={[5, 5]}>
                <Col span={24}>
                    <Row gutter={[10, 10]}>
                        <Col xs={24} lg={5}>
                            <label className="label-container">Email:</label>
                        </Col>
                        <Col xs={24} lg={19}>
                            <p className="text-container">{profileData?.email}</p>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row>
                        <Col xs={24} lg={5}>
                            <label className="label-container"> Access Level:</label>
                        </Col>
                        <Col xs={24} lg={19}>
                            <p className="text-container">
                                <Tag color="#131f28" style={{ width: "130px", textAlign: "center" }}>
                                    {accessLevel?.find((el) => el._id == profileData?.roleId)?.role}
                                </Tag>
                            </p>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row>
                        <Col xs={24} lg={5}>
                            <label className="label-container">Availability:</label>
                        </Col>
                        <Col xs={24} lg={19}>
                            <p className="text-container">{profileData?.available ? "True" : "False"}</p>
                        </Col>
                    </Row>
                </Col>
                {profileData?.calId && (
                    <Col span={24}>
                        <Row>
                            <Col xs={24} lg={5}>
                                <label className="label-container">Calendar Id:</label>
                            </Col>
                            <Col xs={24} lg={19}>
                                <p className="text-container">{profileData?.calId}</p>
                            </Col>
                        </Row>
                    </Col>
                )}
                <Col span={24}>
                    <Row>
                        <Col xs={24} lg={5}>
                            <label className="label-container">Activity:</label>
                        </Col>
                        <Col xs={24} lg={19}>
                            <p className="text-container">
                                <Tag color="#131f28" style={{ width: "130px", textAlign: "center" }}>
                                    {profileData?.active ? "Active" : "Inactive"}
                                </Tag>
                            </p>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row>
                        <Col xs={24} lg={5}>
                            <label className="label-container">Location:</label>
                        </Col>
                        <Col xs={24} lg={19}>
                            <p className="text-container">
                                {address?.name}, {address?.state}
                            </p>
                        </Col>
                    </Row>
                </Col>
                <Col xs={19} lg={10}>
                    <Popconfirm title="Are you Sure you want to reset password?" onConfirm={hanldeReset}>
                        {getUserPermissions("reset-password-action") && <Button loading={isLoading} title="Reset Password" />}
                    </Popconfirm>
                </Col>
            </Row>
        </ProfileWrapper>
    );
};

export default ProfileInfo;
